import * as React from "react";
import Avatar from "@mui/joy/Avatar";
import Chip from "@mui/joy/Chip";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import ButtonGroup from "@mui/joy/ButtonGroup";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import CardActions from "@mui/joy/CardActions";
import IconButton from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";
import LinkedInLogo from "../../assets/img/Social/linkedin-logo.svg";
import GithubLogo from "../../assets/img/Social/github-mark.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";


export default function TeamCard({
  image,
  name,
  education,
  title,
  about,
  linkedInURL,
  githubURL,
  email
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        width: 320,
        maxWidth: "100%",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.3s, box-shadow 0.3s",
        borderRadius: "16px",
        overflow: "hidden",
        border: "none",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
        "&:hover": {
          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <CardContent
        sx={{
          alignItems: "center",
          textAlign: "center",
          padding: "1.5rem 1.5rem 1rem",
          position: "relative",
        }}
      >
        <Avatar
          src={image}
          sx={{ 
            "--Avatar-size": "5rem", 
            marginBottom: "1rem",
            border: "4px solid white",
            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
          }}
        />
        <Typography 
          level="title-lg" 
          sx={{ 
            fontWeight: "bold", 
            color: "#1e40af",
            marginBottom: "0.5rem",
          }}
        >
          {name}
        </Typography>
        
        <Chip
          size="sm"
          variant="soft"
          color="primary"
          sx={{
            marginBottom: "1rem",
            padding: "0.5rem 0.75rem",
            fontWeight: "600",
            borderRadius: "20px",
          }}
        >
          {title}
        </Chip>
        
        <Typography 
          level="body-sm" 
          sx={{ 
            color: "#666", 
            marginBottom: "1rem",
            fontStyle: "italic",
          }}
        >
          {education}
        </Typography>
        
        <Typography 
          level="body-md" 
          sx={{ 
            color: "#444", 
            height: "120px", 
            overflow: "auto",
            marginBottom: "1rem",
            padding: "0 0.5rem",
            lineHeight: "1.6",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#ddd",
              borderRadius: "10px",
            },
          }}
        >
          {about}
        </Typography>
        
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            marginTop: "1rem",
          }}
        >
          {linkedInURL && (
            <a href={linkedInURL} target="_blank" rel="noopener noreferrer">
              <IconButton 
                size="sm" 
                variant="soft" 
                color="primary"
                sx={{
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-3px)",
                  }
                }}
              >
                <img style={{ width: "20px" }} src={LinkedInLogo} alt="LinkedIn" />
              </IconButton>
            </a>
          )}
          
          {githubURL && (
            <a href={githubURL} target="_blank" rel="noopener noreferrer">
              <IconButton 
                size="sm" 
                variant="soft" 
                color="neutral"
                sx={{
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-3px)",
                  }
                }}
              >
                <img style={{ width: "20px" }} src={GithubLogo} alt="GitHub" />
              </IconButton>
            </a>
          )}

          {email && (
            <a href={`mailto:${email}`} style={{ textDecoration: "none" }}>
            <IconButton
              size="sm"
              variant="soft"
              color="neutral"
              sx={{
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "translateY(-3px)",
                },
              }}
            >
              <EmailOutlinedIcon fontSize="small" />
            </IconButton>
          </a>

        )}


        </Box>
      </CardContent>
      
      <CardOverflow sx={{ bgcolor: "background.level1" }}>
        <CardActions buttonFlex="1">
          <ButtonGroup variant="soft" sx={{ width: "100%" }}>
            <a
              style={{
                width: "100%",
                textDecoration: "none",
              }}
              href={`mailto:tofirstland@gmail.com?subject=Hello ${name} from FirstLand&body=I'd like to connect with you!`}
            >
              <Button 
                sx={{ 
                  width: "100%",
                  fontWeight: "600",
                  py: "0.75rem",
                  transition: "all 0.2s",
                  "&:hover": {
                    bgcolor: "primary.600",
                  }
                }}
              >
                Connect
              </Button>
            </a>
          </ButtonGroup>
        </CardActions>
      </CardOverflow>
    </Card>
  );
}
